import { Trans, useTranslation } from "next-i18next"
import styles from "./NewBasicHero.module.scss"
import Image, { ImageProps } from "next/image"

const BasicHero = ({
  background,
  ns,
  heading,
  children,
  lower
}: {
  background: ImageProps
  ns: string
  heading: string,
  lower?: boolean,
  children: JSX.Element
}) => {
  const { t } = useTranslation(ns)

  return (
    <header className={styles.heroContainer}>
      <figure>
        <Image layout="responsive" {...background} alt={background.alt} />
      </figure>
      <section className={`${styles.text} ${lower ? styles.lower : ""}`}>
        <h1 className={styles.h1}>
          <Trans t={t} i18nKey={heading} />
        </h1>
        {children}
      </section>
    </header>
  )
}

export default BasicHero
